/**
 * Ticket LM1: Serverfunktionen der öffentlichen Freebie-Strecke.
 *
 * Bewusst unauthentifiziert (Besucher sind nicht angemeldet), dafür mit
 * Bot-Schutz und ausschließlich lesenden Rückgaben zu veröffentlichten Angeboten.
 */

import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { leadMagnetSignupSchema, slugSchema } from "@/lib/lead-magnets";

export const getLeadMagnetPage = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => z.object({ slug: slugSchema }).parse(data))
  .handler(async ({ data }) => {
    const { getPublishedLeadMagnetOnServer } = await import("@/lib/lead-magnets.server");
    return getPublishedLeadMagnetOnServer(data.slug);
  });

/**
 * Ticket WS1: Übersicht der veröffentlichten Freebies für `/wissen/downloads`.
 * Öffentlich, ausschließlich lesend, ausschließlich veröffentlichte Angebote.
 */
export const listPublishedLeadMagnets = createServerFn({ method: "GET" }).handler(async () => {
  const { listPublishedLeadMagnetsOnServer } = await import("@/lib/lead-magnets.server");
  return listPublishedLeadMagnetsOnServer();
});

export const submitLeadMagnetSignup = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => leadMagnetSignupSchema.parse(data))
  .handler(async ({ data }) => {
    const { submitLeadMagnetSignupOnServer } = await import("@/lib/lead-magnets.server");
    return submitLeadMagnetSignupOnServer(data);
  });


export const confirmLeadMagnetSignup = createServerFn({ method: "POST" })
  .inputValidator((data: { token: string }) =>
    z.object({ token: z.string().trim().min(16).max(200) }).parse(data),
  )
  .handler(async ({ data }) => {
    const { confirmLeadMagnetSignupOnServer } = await import("@/lib/lead-magnets.server");
    return confirmLeadMagnetSignupOnServer(data.token);
  });

export const getLeadMagnetDelivery = createServerFn({ method: "POST" })
  .inputValidator((data: { slug: string; token: string }) =>
    z.object({ slug: slugSchema, token: z.string().trim().min(16).max(200) }).parse(data),
  )
  .handler(async ({ data }) => {
    const { getLeadMagnetDeliveryOnServer } = await import("@/lib/lead-magnets.server");
    return getLeadMagnetDeliveryOnServer(data.slug, data.token);
  });

/**
 * Ticket W14: Kurzfassung eines Freebies für den Anreißer-Abschnitt auf
 * Produktseiten. Lesend, öffentlich, nur veröffentlichte Datensätze.
 */
export const getLeadMagnetTeaser = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => z.object({ slug: slugSchema }).parse(data))
  .handler(async ({ data }) => {
    const { getLeadMagnetTeaserOnServer } = await import("@/lib/lead-magnets.server");
    return getLeadMagnetTeaserOnServer(data.slug);
  });
